import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, LayoutIcon, ShoppingCartIcon, PaintbrushIcon, SearchIcon, ServerIcon } from 'lucide-react';
export function ServicesAccordion() {
  const [openItem, setOpenItem] = useState<string>('web-design');
  const services = [{
    id: 'web-design',
    title: 'Web Design',
    icon: <LayoutIcon size={24} className="text-[#3AA6F9]" data-id="element-129" />,
    content: 'We design and develop responsive, user-friendly websites that look great on all devices. Our web design process focuses on creating an optimal user experience while ensuring your site is fast, secure, and SEO-friendly. We offer various packages to suit different business needs and budgets.',
    features: ['Responsive design for all devices', 'SEO optimization from the start', 'Fast loading speeds', 'User-friendly navigation', 'Content management systems']
  }, {
    id: 'ecommerce',
    title: 'E-commerce',
    icon: <ShoppingCartIcon size={24} className="text-[#3AA6F9]" data-id="element-130" />,
    content: 'Our e-commerce solutions help businesses sell products online with secure, user-friendly online stores. We build e-commerce websites that are easy to manage, secure for transactions, and designed to maximize conversions and sales.',
    features: ['Secure payment processing', 'Inventory management', 'Mobile-optimised shopping experience', 'Product search and filtering', 'Order management systems']
  }, {
    id: 'branding',
    title: 'Branding',
    icon: <PaintbrushIcon size={24} className="text-[#3AA6F9]" data-id="element-131" />,
    content: 'We help businesses establish a strong visual identity with our branding services. From logo design to complete brand guidelines, we create cohesive branding that resonates with your target audience and sets you apart from competitors.',
    features: ['Logo design and variations', 'Colour palette selection', 'Typography guidelines', 'Brand style guides', 'Marketing materials design']
  }, {
    id: 'seo',
    title: 'SEO Setup',
    icon: <SearchIcon size={24} className="text-[#3AA6F9]" data-id="element-132" />,
    content: 'Our SEO services help your website rank higher in search engine results, driving more organic traffic to your business. We implement technical SEO best practices, optimise content, and set up proper tracking to monitor performance.',
    features: ['Keyword research and optimisation', 'Technical SEO implementation', 'Google Analytics setup', 'Google Search Console integration', 'Local SEO optimisation']
  }, {
    id: 'hosting',
    title: 'Hosting & Maintenance',
    icon: <ServerIcon size={24} className="text-[#3AA6F9]" data-id="element-133" />,
    content: 'Keep your website secure, updated, and performing at its best with our hosting and maintenance services. We offer various care plans to ensure your website remains in top condition and continues to deliver results.',
    features: ['Secure hosting with SSL certificates', 'Regular backups and updates', 'Security monitoring and protection', 'Performance optimization', 'Technical support and troubleshooting']
  }];
  const toggleItem = (id: string) => {
    setOpenItem(openItem === id ? '' : id);
  };
  return <div className="space-y-4" data-id="element-134">
      {services.map(service => <div key={service.id} className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden" data-id="element-135">
          <button onClick={() => toggleItem(service.id)} className={`w-full p-4 flex items-center justify-between text-left transition-colors ${openItem === service.id ? 'bg-[#3AA6F9]/10 dark:bg-[#3AA6F9]/20' : 'bg-white dark:bg-[#1E1E1E]'}`} data-id="element-136">
            <div className="flex items-center" data-id="element-137">
              <div className="mr-3" data-id="element-138">{service.icon}</div>
              <h3 className="text-lg font-semibold" data-id="element-139">{service.title}</h3>
            </div>
            <ChevronDownIcon size={20} className={`transition-transform ${openItem === service.id ? 'rotate-180' : ''}`} data-id="element-140" />
          </button>
          <AnimatePresence data-id="element-141">
            {openItem === service.id && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="overflow-hidden" data-id="element-142">
                <div className="p-4 bg-gray-50 dark:bg-gray-900" data-id="element-143">
                  <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-144">
                    {service.content}
                  </p>
                  <h4 className="font-medium mb-2" data-id="element-145">Key Features:</h4>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-146">
                    {service.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-147">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#3AA6F9] mt-1.5 mr-2" data-id="element-148"></div>
                        <span className="text-gray-600 dark:text-gray-300 text-sm" data-id="element-149">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}